import Lenis from 'lenis';

const lenisInstances = [];

const pageLenis = new Lenis({
  lerp: 0.1,
});
lenisInstances.push(pageLenis);

let blockLenisInstances = [];

function initBlockLenis() {
  if (window.innerWidth <= 960) {
    blockLenisInstances.forEach(l => l.destroy());
    blockLenisInstances = [];
    return;
  }

  if (blockLenisInstances.length > 0) return;

  document.querySelectorAll('.secvh__scroll').forEach(el => {
    if (!el.firstElementChild) return;

    const blockLenis = new Lenis({
      wrapper: el,
      content: el.firstElementChild,
      lerp: 0.1,
    });

    blockLenisInstances.push(blockLenis);
    lenisInstances.push(blockLenis);
  });
}

function raf(time) {
  lenisInstances.forEach(l => l.raf(time));
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

window.addEventListener('resize', initBlockLenis);
document.addEventListener('DOMContentLoaded', initBlockLenis);
